import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { customStyles } from "../../assets/table-style";
import "@fortawesome/fontawesome-free/css/all.min.css";
import BASE_URL from "../../assets/global/url";
import swal from "sweetalert";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import { format, set } from "date-fns";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import { useServerSort } from "../../hooks/customHook/sortingHook/useTableSort";
import Select from "react-select";
import { selectCustomStyles } from "../../assets/global/selectCustomStyles";
import useDarkMode from "../../components/Themes/Usedarkmode";
import {
  compactNumberFormat,
  formatCurrency,
  formatToTwoDecimal,
} from "../../utils/numberFormatter";
import DateRangePicker from "../../components/DateRangePicker";
import { Tab, Tabs, Button, Modal, Form } from "react-bootstrap";
// import { useMemo } from "react";
import { getMonthBoundaries, initializeCutoff } from "../../utils/newdate";
import IssuedCheckModalBody from "./components/IssuedCheckModal/issuedCheckModalBody";
import FilterStore from "../../hooks/customHook/FilterStore";

const IssuedCheckAccount = ({ authrztn }) => {
  const { themeSelectStyles } = useDarkMode();
  const userLoggedID = useDecodeToken();
  const pageRestored = useRef(false);
  // const [selectedAccount, setSelectedAccount] = useState("");
  // const [dateFrom, setDateFrom] = useState("");
  // const [dateTo, setDateTo] = useState("");
  // const [searchKeyword, setSearchKeyword] = useState("");
  // const [uniqueAccounts, setUniqueAccounts] = useState([]);
  // const [searchText, setSearchText] = useState("");

  // --- Filters State w/ Lazy Initialization from FilterStore ---
  const [searchText, setSearchText] = useState(() => FilterStore.ICgetSearch());
  useEffect(() => {
    FilterStore.ICsaveSearch(searchText);
  }, [searchText]);
  const [filterColumn, setFilterColumn] = useState(() =>
    FilterStore.ICgetFilterColumn(),
  );
  useEffect(() => {
    FilterStore.ICsaveFilterColumn(filterColumn);
  }, [filterColumn]);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = FilterStore.getTab();
    return ["pending", "paid"].includes(savedTab) ? savedTab : "pending";
  });
  const [selectedAccount, setSelectedAccount] = useState(() => {
    const saved = FilterStore.getSelected();
    return Array.isArray(saved) && saved.length === 0 ? null : saved;
  });

  const [selectedCutOff, setSelectedCutOff] = useState("");
  const [cutOffDate, setCutOffDate] = useState("");
  const [cutOffs, setCutOffs] = useState([]); // Active (isDeleted:false) cutoff periods, used to validate a check's maturity date before allowing Pay / Select Account
  // -------------------------------------------------------------

  const [uniqueAccounts, setUniqueAccounts] = useState([]);
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const [currencyRate, setCurrencyRate] = useState("");
  const [issuedCheckRowData, setIssuedCheckRowData] = useState([]);
  const [paymentData, setPaymentData] = useState({});

  ///total
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);

  const [inboundData, setInboundData] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // const [selectedCutOff, setSelectedCutOff] = useState(""); // state for input select
  // const [cutOffs, setCutOffs] = useState([]); // state for all cut off
  // const [cutOffDate, setCutOffDate] = useState(""); // state for input date
  // const [activeTab, setActiveTab] = useState("pending");
  const [showModalAccountSelection, setShowModalAccountSelection] =
    useState(false);

  const [selectedRowForModalSelection, setSelectedRowForModalSelection] =
    useState();
  const [isSelectedAccountInsufficient, setIsSelectedAccountInsufficient] =
    useState(false);

  const [showDateModal, setShowDateModal] = useState(false);
  const [selectedPayDate, setSelectedPayDate] = useState("");
  const [pendingPayRow, setPendingPayRow] = useState(null);
  // ------- Commented for revising useEffects and handlers, (check below for revised)
  // const handleCutoffChange = (value) => {
  //   let filteredCutoff;
  //   if (value === "All Cutoff" || !value) {
  //     const ascendingSortedCutoff = cutOffs.sort(
  //       (a, b) => new Date(b.from) - new Date(a.from),
  //     );
  //     filteredCutoff = {
  //       from: ascendingSortedCutoff[ascendingSortedCutoff.length - 1]?.from,
  //       to: ascendingSortedCutoff[0]?.to,
  //     };
  //   } else {
  //     [filteredCutoff] = cutOffs.filter((item) => {
  //       return item.id == value;
  //     });
  //   }
  //   return filteredCutoff;
  // };

  // // handle change select cutoff date
  // const handleSelect = (e) => {
  //   const filteredCutoff = handleCutoffChange(e.target.value);
  //   setSearchText("");
  //   pagination.setCurrentPage(1);

  //   setSelectedCutOff(filteredCutoff);
  //   // setSelectedAccount("");
  //   reloadTable(filteredCutoff, selectedAccount?.value);
  // };

  // const fetchCutOff = () => {
  //   // axios
  //   //   .get(BASE_URL + "/cutoff/getCutoffs")
  //   //   .then((res) => {
  //   //     let defaultCutOff = res.data[0];
  //   //     // get the latest date for default cut off
  //   //     for (let index = 1; index < res.data.length; index++) {
  //   //       if (res.data[index].to > defaultCutOff.to) {
  //   //         defaultCutOff = res.data[index];
  //   //       }
  //   //     }
  //   //     if (selectedCutOff) {
  //   //       const filteredCutoff = handleCutoffChange(selectedCutOff?.id);
  //   //       setSelectedCutOff(filteredCutoff);
  //   //       reloadTable(filteredCutoff, selectedAccount?.value);
  //   //     } else {
  //   //       setCutOffs(res.data);
  //   //       setSelectedCutOff(defaultCutOff);
  //   //       reloadTable(defaultCutOff, selectedAccount?.value);
  //   //       fetchAccountListSub3();
  //   //     }
  //   //   })
  //   //   .catch((err) => {
  //   //     console.log(err);
  //   //   });

  //   const boundaries = getMonthBoundaries();
  //   const initialCutoff = initializeCutoff(boundaries);

  //   setSelectedCutOff(initialCutoff);
  //   setCutOffDate(initialCutoff);
  //   setTimeout(() => {
  //     reloadTable(initialCutoff, selectedAccount?.value);
  //     fetchAccountListSub3();
  //   }, 100);
  // };

  // useEffect(() => {
  //   fetchCutOff();
  // }, []);
  // // set start and end date for input date
  // const startAndEndDate = useCallback(() => {
  //   const filteredCutoff = handleCutoffChange(selectedCutOff?.id);

  //   setCutOffDate(filteredCutoff); // set state for input date
  // }, [cutOffs, selectedCutOff]);

  // useEffect(() => {
  //   startAndEndDate();
  // }, [selectedCutOff]);

  // const pagination = useServerPagination(
  //   BASE_URL + "/issuedCheck/getFilteredIssuedCheck",
  //   10,
  // );

  // const reloadTable = (cutOff, accountsName) => {
  //   pagination.updateParams({
  //     startDate: cutOff?.from,
  //     endDate: cutOff?.to,
  //     accountsName,
  //     filterColumn,
  //     searchText,
  //   });
  //   setIsLoading(false);
  //   // axios
  //   //   .get(BASE_URL + "/issuedCheck/getFilteredIssuedCheck", {
  //   //     params: {
  //   //       startDate: cutOff?.from,
  //   //       endDate: cutOff?.to,
  //   //       accountsName,
  //   //       filterColumn,
  //   //       searchText,
  //   //     },
  //   //   })
  //   //   .then((res) => {
  //   //     // const response = res.data;
  //   //     // const accountNames = response.map(
  //   //     //   (item) => item.account_list_id_issued_froms?.account_name
  //   //     // );
  //   //     // const uniqueAccountsSet = [...new Set(accountNames)];
  //   //     // console.log(uniqueAccountsSet);
  //   //     // setUniqueAccounts(uniqueAccountsSet);
  //   //     setInboundData(res.data);
  //   //     setFilteredData(res.data);
  //   //     console.log(res.data);
  //   //     setIsLoading(false);
  //   //   })
  //   //   .catch((err) => console.log(err));
  // };
  // ----------------------------------------------------------------------------

  // ---------- REVISED block of code, useEffect and handlers ----------

  const fetchTotals = async (cutoff, accountsName) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/issuedCheck/getIssuedCheckTotals`,
        {
          params: {
            startDate: cutoff?.from,
            endDate: cutoff?.to,
            accountsName: accountsName || null,
          },
        },
      );
      setTotalPaid(res.data.totalPaid);
      setTotalPayable(res.data.totalPayable);
    } catch (error) {
      console.error(error);
    }
  };

  const pagination = useServerPagination(
    BASE_URL + "/issuedCheck/getFilteredIssuedCheck",
    FilterStore.ICgetPerPage(),
  );

  // No initial sortBy: every header starts neutral until the user picks one
  const sort = useServerSort(pagination);

  const refreshTable = async () => {
    const currentCutoff = selectedCutOff || cutOffDate;

    pagination.updateParams({
      startDate: currentCutoff?.from,
      endDate: currentCutoff?.to,
      accountsName: selectedAccount?.value || null,
      filterColumn: filterColumn,
      searchText: searchText,
      status: activeTab === "pending" ? "Pending" : "Paid",
    });

    await fetchTotals(currentCutoff, selectedAccount?.value);
    await fetchCutOffs(); // keep cutoff list fresh in case one was created/edited/deleted elsewhere
    setIsLoading(false);
  };

  useEffect(() => {
    const savedDates = FilterStore.get();
    let initialCutoff;

    if (savedDates) {
      initialCutoff = savedDates;
    } else {
      const boundaries = getMonthBoundaries();
      initialCutoff = initializeCutoff(boundaries);
    }

    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);
    fetchAccountListSub3();
    fetchCutOffs();
  }, []);

  // Refetch cutoffs when the tab/window regains focus, so a cutoff created,
  // edited, or deleted elsewhere (e.g. another tab, the Monthly Cutoff module)
  // is reflected here without needing a filter change or manual reload.
  useEffect(() => {
    const handleFocus = () => fetchCutOffs();
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, []);

  // --- Debounced API Fetch Effect (Listens to all filters) ---
  useEffect(() => {
    const timer = setTimeout(() => {
      if (selectedCutOff || cutOffDate) {
        refreshTable();
      }
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCutOff,
    cutOffDate,
    selectedAccount,
    filterColumn,
    searchText,
    activeTab,
  ]);

  useEffect(() => {
    setInboundData(pagination.data || []);
  }, [pagination.data]);

  // --- Page / PerPage retention ---
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pagination.currentPage) {
      FilterStore.ICsavePage(pagination.currentPage);
    }
  }, [pagination.currentPage]);

  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.ICsavePerPage(pagination.itemsPerPage);
    }
  }, [pagination.itemsPerPage]);

  useEffect(() => {
    const savedPage = FilterStore.ICgetPage();
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 600);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 600);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAccountListSub3 = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/issuedCheck/getAccountListSub3`,
      );
      const accountNames = response.data.map((item) => {
        return {
          id: item.id,
          account_name: item.account_name,
          module_type: item.account_list_base_sub.module_type,
        };
      });
      // const uniqueAccountsSet = [...new Set(accountNames)];
      // Filter out duplicate IDs
      const uniqueAccountsSet = Array.from(
        new Set(accountNames.map((a) => a.id)),
      ).map((id) => accountNames.find((a) => a.id === id));

      setUniqueAccounts(uniqueAccountsSet);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch all active (isDeleted:false) cutoff periods so we can validate each
  // issued check's maturity date against a cutoff's [from, to] range
  const fetchCutOffs = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/cutoff/getCutoffs`);
      setCutOffs(response.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  // ------- Commented for revising useEffects and handlers, (check above for revised)
  // // useEffect(() => {
  // //   const timer = setTimeout(() => {
  // //     fetchCutOff();
  // //   }, 1000);
  // //   return () => clearTimeout(timer);
  // // }, [searchText]);

  // useEffect(() => {
  //   setInboundData(pagination.data);
  //   setFilteredData(pagination.data);
  // }, [pagination.data]);

  // useEffect(() => {
  //   fetchCutOff();
  // }, [searchText]);

  // useEffect(() => {
  //   setSearchText("");
  //   fetchCutOff();
  // }, [filterColumn]);

  // useEffect(() => {
  //   if (selectedAccount && filterColumn == "account_name") {
  //     setFilterColumn("all");
  //   }
  // }, [selectedAccount]);
  //---------------------------------------------------------------------

  // ------ New Handlers --------
  const handleDateRangeChange = (startDate, endDate) => {
    const cutoff = {
      id: "custom",
      from: startDate,
      to: endDate,
    };
    setSelectedCutOff(cutoff);
    setCutOffDate(cutoff);
    pagination.setCurrentPage(1);

    FilterStore.save(startDate, endDate);
  };

  const handleSelectAccount = (selectedOption) => {
    setSelectedAccount(selectedOption);
    pagination.setCurrentPage(1);

    FilterStore.saveSelected(selectedOption || null);
  };

  const handleClearFilters = () => {
    const boundaries = getMonthBoundaries();
    const initialCutoff = initializeCutoff(boundaries);

    FilterStore.clear();
    FilterStore.ICsaveSearch("");
    FilterStore.ICsaveFilterColumn("all");
    FilterStore.saveTab("pending");

    setSelectedAccount(null);
    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);
    setSearchText("");
    setFilterColumn("all");
    setActiveTab("pending");
    pagination.setCurrentPage(1);
  };
  // ------------------------------------------------------------------

  const dataList = inboundData?.map((data, i) => {
    // const transactionDate = new Date(data.transaction_date);
    // const formattedDate = transactionDate.toLocaleDateString("en-PH", {
    //   year: "numeric",
    //   month: "short",
    //   day: "numeric",
    // });

    return {
      key: i,
      id: data.id,
      account_list_id_issued_from: data.account_list_id_issued_from,
      account_list_id_issued_to: data.account_list_id_issued_to,
      account_list_id_issued_froms: data.account_list_id_issued_froms,
      account_list_id_issued_tos: data.account_list_id_issued_tos,
      transaction_date: data.transaction_date,
      check_number: data.check_number,
      transaction_number: data.transaction_number,
      module_from: data.module_from,
      description: data.description,
      amount: data.amount,
      status: data.status,
      createdAt: data.createdAt,
    };
  });

  const handlePay = async (
    id,
    account_list_id_issued_from,
    amount,
    checkNo,
    date,
    transaction_number,
    module_from,
    description,
    currency,
    rowData,
    selectedPayDate,
  ) => {
    console.log(rowData);
    // const amountToUse =
    //   rowData.amount_to_deduct != null ? rowData.amount_to_deduct : amount;

    // console.log("amoun to use", amountToUse, rowData.amount_to_deduct);

    // const res = await axios.get(
    //   `${BASE_URL}/issuedCheck/validateIssuedCheck/${account_list_id_issued_from}`,
    // );// one of the comment

    // Check if this is a liability account or payable transaction
    // const isLiabilityAccount =
    //   module_from === "Liabilities Account" ||
    //   module_from?.toLowerCase().includes("payable") ||
    //   description?.toLowerCase().includes("payable") ||
    //   description?.toLowerCase().includes("liability");

    // Only show insufficient balance modal for non-liability accounts
    // if (amountToUse > res.data.amount) {
    //   swal({
    //     title: "Oppss!",
    //     text: "Insufficient Balance",
    //     icon: "error",
    //     buttons: false,
    //     timer: 2000,
    //   });
    //   return;
    // }/// second comment

    // if (currency.currency_name !== "PHP" || currency.id !== 1) {
    //   setIssuedCheckRowData(rowData);
    //   setPaymentData({
    //     id,
    //     account_list_id_issued_from,
    //     amount,
    //     checkNo,
    //     date,
    //     transaction_number,
    //     module_from,
    //     description,
    //     userLoggedID,
    //     rowData,
    //     account_list_id_issued_to: rowData.account_list_id_issued_to,
    //   });
    //   handleShowModal();
    //   return;
    // }

    try {
      const toPay = await swal({
        title: "Are you sure?",
        text: "Once paid, you will not be able to recover this check",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      if (toPay) {
        await axios
          .post(BASE_URL + "/issuedCheck/v2/payIssuedCheck", {
            id,
            account_list_id_issued_from,
            amount,
            checkNo,
            date,
            transaction_date: date,
            transaction_number,
            module_from,
            description,
            userLoggedID,
            amountToDeduct:
              rowData.amount_to_deduct != null ? rowData.amount_to_deduct : 0,
            account_list_id_issued_to: rowData.account_list_id_issued_to,
            currencyName: rowData?.currencyName ?? "PHP",
            currencyRate: rowData?.exchangeRate ?? 1,
            rowData,
            selectedPayDate,
          })
          .then((res) => {
            if (res.status === 200) {
              swal({
                title: "Check Paid",
                text: "The check has been paid",
                icon: "success",
                timer: 2000,
              }).then(() => {
                // const [filteredCutoff] = cutOffs.filter((item) => {
                //   return item.id === selectedCutOff?.id;
                // });
                // reloadTable(filteredCutoff, null);
                pagination.refreshData();
                fetchTotals(
                  selectedCutOff || cutOffDate,
                  selectedAccount?.value,
                );
              });
            } else if (res.status === 202) {
              swal({
                title: "Oppss!",
                text: `Insufficient Balance`,
                icon: "error",
                buttons: false,
                timer: 2000,
              });
              return;
            } else {
              swal({
                title: "Something went wrong",
                text: "Please contact your support immediately",
                icon: "error",
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 409) {
              swal({
                title: "Action Prohibited",
                text: error.response.data.message,
                icon: "error",
                button: true,
              });
            } else if (error.response && error.response.status === 401) {
              // Imbalance checker: payment rolled back
              swal({
                title: error.response.data.title,
                text: error.response.data.message,
                icon: "error",
              });
            }
          });
      }
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  const handleSubmit = async () => {
    try {
      if (currencyRate === "") {
        swal({
          title: "Field required.",
          text: "Please fill in the Foreign rate.",
          icon: "error",
          timer: 2000,
        });
        return;
      }

      const toPay = await swal({
        title: "Are you sure?",
        text: "Once paid, you will not be able to recover this check",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (toPay) {
        const {
          id,
          account_list_id_issued_from,
          amount,
          checkNo,
          date,
          transaction_number,
          module_from,
          description,
          userLoggedID,
          rowData,
          account_list_id_issued_to,
        } = paymentData;

        console.log(paymentData, "payment", id);

        await axios
          .post(BASE_URL + "/issuedCheck/payIssuedCheck", {
            id,
            account_list_id_issued_from,
            amount,
            checkNo,
            date,
            transaction_number,
            module_from,
            description,
            userLoggedID,
            issuedCheckRowData,
            currencyRate,
            amountToDeduct:
              issuedCheckRowData.amount_to_deduct != null
                ? issuedCheckRowData.amount_to_deduct
                : 0,
            account_list_id_issued_to,
          })
          .then((res) => {
            if (res.status === 200) {
              swal({
                title: "Check Paid",
                text: "The check has been paid",
                icon: "success",
                timer: 2000,
              }).then(() => {
                // const [filteredCutoff] = cutOffs.filter((item) => {
                //   return item.id === selectedCutOff?.id;
                // });
                // reloadTable(filteredCutoff, null);
                pagination.refreshData();
                fetchTotals(
                  selectedCutOff || cutOffDate,
                  selectedAccount?.value,
                );
                handleCloseModal();
              });
            } else {
              swal({
                title: "Something went wrong",
                text: "Please contact your support immediately",
                icon: "error",
                timer: 2000,
              });
            }
          });
      }
    } catch (error) {
      console.error(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  // List of currency symbol
  const currencySymbol = {
    PHP: "₱",
    JPY: "¥",
    USD: "$",
    EUR: "€",
    HKD: "HK$",
    CNY: "CN¥",
  };

  /// console.log("[getName]: ", inboundData);

  // Checks whether a check's Maturity Date falls within an active cutoff period.
  // A cutoff only counts if isDeleted is false AND the maturity date is between
  // that cutoff's from/to range (inclusive).
  const isMaturityDateWithinCutoff = (maturityDate) => {
    if (!maturityDate || !cutOffs?.length) return false;

    const formattedMaturityDate = format(new Date(maturityDate), "yyyy-MM-dd");

    return cutOffs.some((cutoff) => {
      if (cutoff.isDeleted) return false; // guard, even though /getCutoffs already excludes deleted cutoffs
      if (!cutoff.from || !cutoff.to) return false;

      const from = format(new Date(cutoff.from), "yyyy-MM-dd");
      const to = format(new Date(cutoff.to), "yyyy-MM-dd");

      return formattedMaturityDate >= from && formattedMaturityDate <= to;
    });
  };

  // Account Options for dropdown select
  const accountOptions = uniqueAccounts.map((item) => ({
    value: item.id,
    label: `${item.module_type} - ${item.account_name}`,
  }));

  const columns = [
    {
      name: "Bank Account",
      sortField: "bank_account",
      selector: (row) => row.account_list_id_issued_froms?.account_name || "--",
    },
    {
      name: "Date Process",
      sortField: "process_date",
      selector: (row) =>
        row.processDate ? format(row.processDate, "MMM/dd/yyyy") : "--",
    },
    {
      name: "Maturity Date",
      sortField: "transaction_date",
      selector: (row) => format(row.transaction_date, "MMM/dd/yyyy"),
    },
    {
      name: "Check Number",
      sortField: "check_number",
      selector: (row) => row.check_number,
    },
    {
      name: "Transaction #",
      sortField: "transaction_number",
      selector: (row) => row.transaction_number,
    },

    {
      name: "Issued To",
      sortField: "issued_to",
      selector: (row) =>
        row.account_list_id_issued_tos?.account_name || row.issuedTo,
    },
    {
      name: "Subject From",
      sortField: "module_from",
      selector: (row) => row.module_from,
    },
    {
      name: "Description",
      sortField: "description",
      selector: (row) => row.description,
    },
    {
      name: "Amount",
      sortField: "amount",
      selector: (row) =>
        formatCurrency(
          row.amount,
          row.account_list_id_issued_froms?.currency?.currency_name,
        ),
    },
    {
      name: "Created Date",
      sortField: "createdAt",
      selector: (row) => format(row.createdAt, "MMM/dd/yyyy"),
      // row.createdAt
      //   ? new Date(row.createdAt).toISOString().split("T")[0]
      //   : "N/A",
    },
    // {
    //   name: "Exchange Rate Used",
    //   cell: (row) => (
    //     <div>
    //       {currencySymbol["PHP"]}
    //       {row.exchangeRate.toLocaleString("en-US", {
    //         minimumFractionDigits: String(row.exchangeRate).length > 4 ? 3 : 2,
    //         maximumFractionDigits: String(row.exchangeRate).length > 4 ? 3 : 2,
    //       })}
    //     </div>
    //   ),
    // },
    // {
    //   name: "Converted Amount",
    //   cell: (row) => (
    //     <div>
    //       {currencySymbol["PHP"]}
    //       {row.convertedAmount.toLocaleString("en-US", {
    //         minimumFractionDigits: 2,
    //         maximumFractionDigits: 2,
    //       })}
    //     </div>
    //   ),
    // },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <div
          style={{
            padding: "5px 10px",
            borderRadius: "5px",
            color: row.status
              ? row.status === "Pending"
                ? "#FFA500"
                : "#3B9F3F"
              : "initial",
            textTransform: "uppercase",
            fontWeight: "bold",
          }}>
          {row.status}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => {
        const issuedDate = new Date(row.transaction_date); // Convert Issued Date to Date object
        const today = new Date(); // Get today's date
        const isDatePast = issuedDate < today; // Check if the Issued Date is past
        const isAccountFromAvailable = row.account_list_id_issued_froms
          ? true
          : false;
        // Maturity Date must fall within an active (isDeleted:false) cutoff range
        const isCutoffValid = isMaturityDateWithinCutoff(row.transaction_date);
        const isActionDisabled =
          row.status !== "Pending" || !isDatePast || !isCutoffValid;
        const disabledTitle = !isCutoffValid
          ? "No active cutoff period covers this check's maturity date."
          : undefined;
        // const filteredData = dataList.filter((item) => {
        //   const isAccountMatch = selectedAccount
        //     ? item.account_list_id_issued_from === selectedAccount
        //     : true;

        //   const isDateMatch =
        //     dateFrom && dateTo
        //       ? new Date(item.transaction_date) >= new Date(dateFrom) &&
        //         new Date(item.transaction_date) <= new Date(dateTo)
        //       : true;

        //   const isKeywordMatch = searchKeyword
        //     ? Object.values(item)
        //         .join(" ")
        //         .toLowerCase()
        //         .includes(searchKeyword.toLowerCase())
        //     : true;

        //   return isAccountMatch && isDateMatch && isKeywordMatch;
        // });

        return (
          <div className="d-flex gap-3 align-items-center">
            {isAccountFromAvailable ? (
              <button
                type="button"
                onClick={() => handlePayButtonClick(row)}
                className={`btn btn-primary ${
                  isActionDisabled ? "disabled" : ""
                }`}
                disabled={isActionDisabled}
                title={disabledTitle}
                style={{
                  cursor: isActionDisabled ? "not-allowed" : "pointer",
                }}>
                Pay
              </button>
            ) : (
              // if walang accountsFrom mag siselect ng Account
              <button
                onClick={() => handleShowModalAccountSelection(row)}
                type="button"
                className={`btn btn-primary ${
                  isActionDisabled ? "disabled" : ""
                }`}
                disabled={isActionDisabled}
                title={disabledTitle}
                style={{
                  cursor: isActionDisabled ? "not-allowed" : "pointer",
                }}>
                Select Account
              </button>
            )}

            <>
              {[
                "Local Expenses",
                "Overseas Expenses",
                "Local Payable",
                "Overseas Payable",
              ].includes(row.module_from) ? (
                <i
                  className="fas fa-trash"
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontSize: "1.5rem",
                  }}
                  onClick={() => handleDeleteIssuedCheck(row.id)}></i>
              ) : null}
            </>
          </div>
        );
      },
    },
  ];

  const handleShowModalAccountSelection = (row) => {
    setShowModalAccountSelection(true);
    setSelectedRowForModalSelection(row);
  };

  // if (authrztn.includes("IssuedCheck-Delete")) {
  //   columns.push({
  //     name: "",
  //     selector: (row) =>
  //       [
  //         "Local Expenses",
  //         "Overseas Expenses",
  //         "Local Payable",
  //         "Overseas Payable",
  //       ].includes(row.module_from) ? (
  //         <i
  //           className="fas fa-trash"
  //           style={{ cursor: "pointer", color: "red", fontSize: "1.5rem" }}
  //           onClick={() =>
  //             handleDeleteIssuedCheck(row.id, row.transaction_date)
  //           }
  //         ></i>
  //       ) : null,
  //   });
  // }

  // const handleDeleteIssuedCheck = async (issuedCheckId, issuedCheckDate) => {
  //   swal({
  //     title: "Confirm Deletion",
  //     text: "Are you sure you want to delete?",
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   }).then(async (willDelete) => {
  //     if (willDelete) {
  //       try {
  //         const response = await axios.delete(
  //           `${BASE_URL}/issuedCheck/deleteIssuedCheck/${issuedCheckId}/${issuedCheckDate}`,
  //         );
  //         if (response.status === 200) {
  //           swal({
  //             title: "Issued Check Deleted Successfully!",
  //             text: "The issued check has been successfully deleted.",
  //             icon: "success",
  //             button: "OK",
  //           }).then(() => {
  //             // reloadTable();
  //           });
  //         } else if (response.status === 202) {
  //           const { dateIssued, CutoffName } = response.data;
  //           swal({
  //             title: "Delete Prohibited!",
  //             text: `Issued check cannot be deleted as its date issued (${dateIssued}) falls within the posted cutoff period named "${CutoffName}".`,
  //             icon: "warning",
  //             button: "OK",
  //           });
  //         } else if (response.status === 203) {
  //           swal({
  //             icon: "error",
  //             title: "Something went wrong",
  //             text: "Please contact our support team for assistance.",
  //           });
  //         } else {
  //           swal({
  //             icon: "error",
  //             title: "Something went wrong",
  //             text: "Please contact our support team for assistance.",
  //           });
  //         }
  //       } catch (err) {
  //         console.log(err);
  //         swal({
  //           icon: "error",
  //           title: "Error",
  //           text: "An error occurred while deleting the collection.",
  //         });
  //       }
  //     }
  //   });
  // };

  const handlePayButtonClick = (row) => {
    const rowData = inboundData.find((data) => data.id === row.id);
    setPendingPayRow({ row, rowData });
    // Default the pay date to today; the user can still change it
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    setSelectedPayDate(today);
    setShowDateModal(true);
  };

  const handleDateConfirm = () => {
    if (!selectedPayDate) {
      swal({
        title: "Date Required",
        text: "Please pick a pay date before proceeding.",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    }
    setShowDateModal(false);
    const { row, rowData } = pendingPayRow;
    handlePay(
      row.id,
      row.account_list_id_issued_from,
      row.amount,
      row.check_number,
      row.transaction_date,
      row.transaction_number,
      row.module_from,
      row.description,
      row.account_list_id_issued_froms.currency,
      rowData,
      selectedPayDate, // Ni-select na pay date
    );
  };

  const handleDeleteIssuedCheck = async (issuedCheckId) => {
    try {
      const deleteIssuedCheck = await swal({
        icon: "warning",
        title: "Confirm Deletion",
        text: "Are you sure you want to delete?",
        buttons: ["Cancel", "Yes"],
        dangerMode: true,
      });

      if (!deleteIssuedCheck) return; // Guard clause

      const res = await axios.delete(
        `${BASE_URL}/issuedCheck/delete-issued-check/${issuedCheckId}/${userLoggedID}`,
      );

      if (res.status === 200) {
        await swal({
          icon: "success",
          title: "Successfully Deleted",
          text: "Issued check successfully deleted.",
        });

        await refreshTable();
      }
    } catch (error) {
      console.error(error);

      if (error.response && error.response.status === 400) {
        swal({
          icon: "error",
          title: error.response.data.title,
          text: error.response.data.message,
        });
        return;
      }

      swal({
        icon: "error",
        title: "Something went wrong.",
        text: "Please contact our support team for assistance.",
      });
    }
  };

  // Commented revised (check above)
  // useEffect(() => {
  //   console.log("Dataaa", dataList);
  // }, [dataList]);

  // useEffect(() => {
  //   const filtered = inboundData?.filter((item) => {
  //     const accountMatch = selectedAccount
  //       ? item.account_list_id_issued_froms?.account_name === selectedAccount
  //       : true;
  //     const dateMatch =
  //       dateFrom && dateTo
  //         ? new Date(item.transaction_date) >= new Date(dateFrom) &&
  //           new Date(item.transaction_date) <= new Date(dateTo)
  //         : true;
  //     const keywordMatch = searchKeyword
  //       ? Object.values(item)
  //           .join(" ")
  //           .toLowerCase()
  //           .includes(searchKeyword.toLowerCase())
  //       : true;

  //     return accountMatch && dateMatch && keywordMatch;
  //   });
  //   setFilteredData(filtered);
  // }, [selectedAccount, dateFrom, dateTo, searchKeyword, inboundData]);

  // const totalPaid = dataList
  //   ?.filter((item) => item.status === "Paid")
  //   .reduce(
  //     (total, item) =>
  //       total +
  //       parseFloat(
  //         item.amount *
  //           item.account_list_id_issued_froms?.currency.currency_rate || 0,
  //       ),
  //     0,
  //   );

  // const totalPayable = dataList
  //   ?.filter((item) => item.status === "Pending")
  //   .reduce(
  //     (total, item) =>
  //       total +
  //       parseFloat(
  //         item.amount *
  //           item.account_list_id_issued_froms?.currency?.currency_rate || 0,
  //       ),
  //     0,
  //   );

  // Commented revised (check above)
  // const handleDateRangeChange = (startDate, endDate) => {
  //   const cutoff = {
  //     id: "custom",
  //     from: startDate,
  //     to: endDate,
  //   };
  //   setSelectedCutOff(cutoff);
  //   setCutOffDate(cutoff);
  //   setSearchText("");
  //   pagination.setCurrentPage(1);
  //   // setSelectedAccount("");
  //   reloadTable(cutoff, selectedAccount?.value);
  // };

  // Calculate tab counts using useMemo
  const pendingCount = pagination.pendingCount || 0;
  const paidCount = pagination.paidCount || 0;

  // Filter data based on active tab
  // const tabFilteredData = useMemo(() => {
  //   return inboundData?.filter((data) =>
  //     activeTab === "pending"
  //       ? data.status === "Pending"
  //       : data.status === "Paid",
  //   );
  // }, [inboundData, activeTab]);
  const tabFilteredData = inboundData;

  // Plain render function (not a component) — defining a component inside
  // render remounts the DataTable on every re-render and resets its scroll
  const renderTabContent = (data) => (
    <div className="data-table-cell-width">
      <DataTable
        columns={sort.sortColumns(columns)}
        data={data}
        customStyles={customStyles}
        className="dataTable"
        {...sort.sortProps}
      />
      <PaginationControls {...pagination} />
    </div>
  );

  // ------------- handle Submit Issued Check when selecting a account -------------
  const handleModalSelectAccountSubmit = async (formData) => {
    const { account3, currencyName, currencyRate } = formData;
    const row = selectedRowForModalSelection;

    try {
      const willPay = await swal({
        title: "Confirm Payment",
        text: "This will update the account and mark the check as PAID immediately. Are you sure?",
        icon: "warning",
        buttons: ["Cancel", "Yes, Pay Now"],
        dangerMode: true,
      });

      if (!willPay) return;

      // Construct Payload for /v2/payIssuedCheck
      const payload = {
        id: row.id,
        account_list_id_issued_from: account3,
        amount: row.amount,
        checkNo: row.check_number,
        date: row.transaction_date,
        transaction_number: row.transaction_number,
        module_from: row.module_from,
        description: row.description,
        userLoggedID: userLoggedID,
        amountToDeduct: row.amount_to_deduct != null ? row.amount_to_deduct : 0,
        account_list_id_issued_to: row.account_list_id_issued_to,
        currencyName: currencyName || "PHP",
        currencyRate: currencyRate || 1,
        rowData: row,
      };

      const res = await axios.post(
        `${BASE_URL}/issuedCheck/v2/payIssuedCheck`,
        payload,
      );

      if (res.status === 200) {
        swal({
          title: "Success",
          text: "Account updated and Check marked as Paid.",
          icon: "success",
          timer: 2000,
        }).then(() => {
          // Fixed the modal after submit mag rerefresh table
          setShowModalAccountSelection(false);
          setSelectedRowForModalSelection(null);
          // reloadTable(selectedCutOff, selectedAccount?.value);
          pagination.refreshData();
          fetchTotals(selectedCutOff || cutOffDate, selectedAccount?.value);
        });
      }
    } catch (error) {
      console.error("Payment Error:", error);

      if (error.response && error.response.status === 409) {
        swal({
          title: "Action Denied",
          text: "The issued date falls within a posted cutoff period.",
          icon: "error",
        });
      } else if (error.response && error.response.status === 401) {
        // Imbalance checker: payment rolled back
        swal({
          title: error.response.data.title,
          text: error.response.data.message,
          icon: "error",
        });
      } else {
        swal({
          title: "Error",
          text: "Failed to update and pay the account. Please try again.",
          icon: "error",
        });
      }
    }
  };
  // ------------- handle Submit Issued Check when selecting a account -------------

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {isLoading ? (
        <div className="loading-container">
          <ThreeDot
            variant="brick-stack"
            color="#6290FE"
            size="large"
            text="Loading Data..."
            textColor=""
          />
        </div>
      ) : authrztn.includes("IssuedCheck-View") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3 text-uppercase">Issued Checks</span>
            </div>

            <div>
              {/* <Link
            to="/purchases/create_payable"
            className="btn btn-primary d-flex flex-row align-items-center title-button"
          >
            <i className="bx bx-plus fs-5"></i> Create
          </Link> */}
            </div>
          </div>
          <div className="container-fluid">
            <div className="row p-2 mx-auto">
              <div className="col-sm w-100 p-3 payable-card">
                <div className="w-100 border p-3 shadow-sm rounded h-100">
                  <div className=" d-flex flex-row align-items-center payable-icon">
                    <i class="bx bx-bar-chart-alt fs-3 h-100"></i>
                    <h3>Total Paid</h3>
                  </div>

                  <div className="mt-2 d-flex flex-column payable-card-desc">
                    <h1
                      className="payable-amount"
                      title={formatToTwoDecimal(totalPaid)}
                      style={{
                        cursor: "default",
                        color: "var(--widget-number-color)",
                      }}>
                      {formatToTwoDecimal(totalPaid)}
                    </h1>
                    <span className="text-secondary">
                      NUMBER OF TRANSACTION:{" "}
                      <strong>
                        {" "}
                        {
                          dataList?.filter((item) => item.status === "Paid")
                            .length
                        }
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-sm w-100 p-3 payable-card">
                <div className="w-100 border p-3 shadow-sm rounded h-100">
                  <div className=" d-flex flex-row align-items-center payable-icon">
                    <i className="bx bx-credit-card fs-3 h-100"></i>
                    <h3>Total Payable</h3>
                  </div>

                  <div className=" mt-2 d-flex flex-column payable-card-desc">
                    <h1
                      className="payable-amount"
                      title={formatToTwoDecimal(totalPayable)}
                      style={{
                        cursor: "default",
                        color: "var(--widget-number-color)",
                      }}>
                      {formatToTwoDecimal(totalPayable)}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mx-auto mt-2">
              <div className="col-sm mb-2">
                <label htmlFor="">Account</label>
                {/* <select
                  className="form-select"
                  value={selectedAccount}
                  onChange={(e) => {
                    setSelectedAccount(e.target.value);
                    const [filteredCutoff] = cutOffs.filter((item) => {
                      return item.id === selectedCutOff?.id;
                    });
                    reloadTable(filteredCutoff, e.target.value);
                  }}
                  onMouseDown={(e) => {
                    if (uniqueAccounts.length === 0) {
                      e.preventDefault();
                      swal({
                        icon: "warning",
                        title: "No Account Found",
                        text: "No account found. Please add an account first",
                      });
                      return;
                    }
                  }}
                >
                  <option value="">All Account</option>
                  {uniqueAccounts.map((account, index) => (
                    <option key={index} value={account?.id}>
                      {account?.account_name}
                    </option>
                  ))}
                </select> */}
                <Select
                  options={accountOptions}
                  value={selectedAccount}
                  // onChange={(selectedOption) => {
                  //   setSelectedAccount(selectedOption);

                  //   // const filteredCutoff = handleCutoffChange(
                  //   //   selectedCutOff?.id
                  //   // );

                  //   const currentCutoff = selectedCutOff || cutOffDate;

                  //   reloadTable(currentCutoff, selectedOption?.value);
                  // }}
                  onChange={handleSelectAccount}
                  onMenuOpen={() => {
                    if (uniqueAccounts.length === 0) {
                      swal({
                        icon: "warning",
                        title: "No Account Found",
                        text: "No account found. Please add an account first",
                      });
                      return;
                    }
                  }}
                  menuIsOpen={uniqueAccounts.length === 0 ? false : undefined}
                  placeholder={`All Account`}
                  styles={themeSelectStyles(
                    selectCustomStyles(selectedAccount),
                  )}
                  isSearchable
                  isClearable
                />
              </div>
              <div className="col-sm mb-2">
                <DateRangePicker
                  startDate={
                    cutOffDate?.from ? new Date(cutOffDate.from) : null
                  }
                  endDate={cutOffDate?.to ? new Date(cutOffDate.to) : null}
                  onDateRangeChange={handleDateRangeChange}
                  label="Date Range"
                />

                {/* <label htmlFor="cutOff">Cutoff</label>
                <select
                  value={selectedCutOff?.id}
                  onChange={handleSelect}
                  className="form-select"
                  onMouseDown={(e) => {
                    if (cutOffs.length === 0) {
                      e.preventDefault();
                      swal({
                        icon: "warning",
                        title: "No Cutoff Found",
                        text: "No cutoff records found. Please create a cutoff first in Monthly Cutoff Module.",
                      });
                      return;
                    }
                  }}
                >
                  <option value="All Cutoff">All</option>
                  {cutOffs.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
              </div>
              {/* <div className="col-sm mb-2">
                <label htmlFor="">From</label>
                <input
                  type="date"
                  name="cutoff-start-date"
                  id="cutoff-start-date"
                  className="form-control"
                  value={cutOffDate?.from}
                  readOnly
                  // onChange={(e) => setDateFrom(e.target.value)}
                />
                <DatePicker
                  selected={cutOffDate?.from}
                  dateFormat="MMM/dd/yyyy"
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-sm mb-2">
                <label htmlFor="">To</label>
                <input
                  type="date"
                  className="form-control"
                  name="cutoff-end-date"
                  id="cutoff-end-date"
                  value={cutOffDate?.to}
                  readOnly
                  // onChange={(e) => setDateTo(e.target.value)}
                />
                <DatePicker
                  selected={cutOffDate?.to}
                  dateFormat="MMM/dd/yyyy"
                  className="form-control"
                  readOnly
                />
              </div> */}
              {/* <div className="col-sm d-flex flex-row align-items-end mb-2 filter-btn-container w-100"> */}
              {/* <button className="btn w-100">Apply Filter</button>
                <button
                  className="btn btn-secondary w-100"
                  onClick={() => {
                    setSelectedAccount("");
                    setDateFrom("");
                    setDateTo("");
                    setSearchKeyword("");
                    setFilteredData(inboundData); // Reset to original data
                  }}
                >
                  Clear Filter
                </button> */}
              <div className="col-sm d-flex flex-row align-items-end mb-2 filter-btn-container w-100">
                <button
                  className="btn btn-primary w-100"
                  onClick={handleClearFilters}>
                  <i className="bx bx-reset me-1"></i> Clear All Filters
                </button>
              </div>
            </div>
            <div className="w-100 mt-2 container-fluid">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    FilterStore.ICsaveSearch(e.target.value);
                  }}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary dropdown-toggle-split"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i className="fa-solid fa-sliders"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "all" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("all")}>
                      All
                    </button>
                  </li>
                  {/* <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "account" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("account")}
                  >
                    Account
                  </button>
                </li> */}
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "account_name" ? "active" : ""
                      }`}
                      onClick={() => {
                        setFilterColumn("account_name");
                        // setSelectedAccount("");
                        setSelectedAccount(null);
                      }}>
                      Account Name
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "issued_date" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("issued_date")}>
                      Maturity Date
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "check_number" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("check_number")}>
                      Check Number
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "transaction_number" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("transaction_number")}>
                      Transaction #
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "created_date" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("created_date")}>
                      Created Date
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "issued_to" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("issued_to")}>
                      Issued To
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "subject_from" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("subject_from")}>
                      Subject From
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "description" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("description")}>
                      Description
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "amount" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("amount")}>
                      Amount
                    </button>
                  </li>
                  {/* <li>
                    <button
                      className={`dropdown-item ${
                        filterColumn === "status" ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn("status")}
                    >
                      Status
                    </button>
                  </li> */}
                </ul>
              </div>
            </div>

            {/* data table */}
            <div
              className="w-100 mt-3 container-fluid"
              // style={{ maxWidth: "78.5vw" }}
            >
              <Tabs
                transition={false}
                mountOnEnter
                unmountOnExit={false}
                activeKey={activeTab}
                onSelect={(tab) => {
                  setActiveTab(tab);
                  FilterStore.saveTab(tab);
                  pagination.setCurrentPage(1);
                }}
                id="issued-check-status-tabs"
                className="mb-3">
                <Tab eventKey="pending" title={`Pending (${pendingCount})`}>
                  {renderTabContent(tabFilteredData)}
                </Tab>

                <Tab eventKey="paid" title={`Paid (${paidCount})`}>
                  {renderTabContent(tabFilteredData)}
                </Tab>
              </Tabs>
            </div>

            {/* Currency Rate Modal */}
            <Modal show={show} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Currency Rate</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <label htmlFor="currency-rate" className="mb-2">
                    Foreign Rate
                  </label>
                  <input
                    type="number"
                    id="currency-rate"
                    name="currency_rate"
                    className="form-control"
                    placeholder="Enter Foreign Rate"
                    value={currencyRate}
                    onChange={(e) => setCurrencyRate(e.target.value)}
                    onKeyDown={(e) => {
                      ["-", "e", "+"].includes(e.key) && e.preventDefault();
                    }}
                    min={0}
                    required
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}>
                  Submit
                </button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={showModalAccountSelection}
              onHide={() => {
                setShowModalAccountSelection(false);
                setIsSelectedAccountInsufficient(false);
              }}
              backdrop="static"
              keyboard={false}
              size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Select Account</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <IssuedCheckModalBody
                  rowData={selectedRowForModalSelection}
                  onSave={handleModalSelectAccountSubmit}
                  onBalanceChange={(insufficient) =>
                    setIsSelectedAccountInsufficient(insufficient)
                  }
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowModalAccountSelection(false)}>
                  Close
                </Button>

                <Button
                  variant="primary"
                  type="submit"
                  form="issued-check-form"
                  disabled={isSelectedAccountInsufficient}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Pay Date Modal — shown before Pay proceeds */}
            <Modal
              show={showDateModal}
              onHide={() => setShowDateModal(false)}
              centered>
              <Modal.Header closeButton>
                <Modal.Title>Select Pay Date</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="mb-2 text-muted" style={{ fontSize: "0.875rem" }}>
                  Please pick a Pay Date before proceeding with the payment.
                </p>
                <Form.Label>Pay Date</Form.Label>
                <DatePicker
                  selected={selectedPayDate}
                  onChange={(date) => setSelectedPayDate(date)}
                  className="form-control"
                  placeholderText="Select a date"
                  dateFormat="MM/dd/yyyy"
                  isClearable
                  autoFocus
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowDateModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleDateConfirm}>
                  Confirm &amp; Pay
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}
    </div>
  );
};

export default IssuedCheckAccount;
